import { render, staticRenderFns } from "./NormalOrder.vue?vue&type=template&id=6a76b34d"
import script from "./NormalOrder.vue?vue&type=script&lang=js"
export * from "./NormalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports